import pdpSliderGallery from './rbata.pdpSliderGallery';

import zoomView from '../utils/zoom-view';

const pdpZoom = {
    zoom:        undefined,
    zoomEnabled: false,
    /**
     * When overlay open, cache selectors and bind basic events.
     * Het source of active image index
     */
    init() {
        this.cacheSelectors();
        this.bindEvents();
        this.updateSrc(pdpSliderGallery.sliderGalleryImageSources[pdpSliderGallery.currentImageIndex]);

        this.zoom = new zoomView({
            elementClass:  '.pdp-pan__wrapper',
            zoomInButton:  '.js-pdp-zoom__zoom-in',
            zoomOutButton: '.js-pdp-zoom__zoom-out',
            callbackMethod: this.resetCallback
        })

        this.zoom.init();
        window.zoom = pdpZoom.zoom;
    },

    cacheSelectors() {
        this.$body = $('body');
        this.zoomImage = this.$body.find('#js-pdp-pan__image');
        this.zoomOverlay = this.$body.find('#js-pdp-pan__overlay');
        this.openPanButton = this.$body.find('#js-pdp-zoom__open-pan');
    },

    /**
     * Exchange src of and imag to zoom image. Also controlled from pdpSliderGallery
     * @param src
     */
    updateSrc(src) {
        this.zoomImage.attr('src', src);
    },

    /**
     * Zoom control events, zoom buttons, wheel zoom and preventing interupting actions like mousedown
     */
    bindEvents() {
        this.openPanButton.on('click', pdpZoom.showZoomOverlay);
    },

    /**
     * Show zoom overlay
     */
    showZoomOverlay() {
        if (!pdpZoom.zoomEnabled) {
            pdpZoom.zoomEnabled = true;
            pdpZoom.zoomOverlay.addClass('pdp-pan__overlay--active');
            pdpZoom.zoom.actionZoomIn();
        }
    },

    /**
     * Callback when zoom is not active anymore
     */
    resetCallback() {
        pdpZoom.zoomEnabled = false;

        setTimeout(() => {
            pdpZoom.zoomOverlay.removeClass('pdp-pan__overlay--active');
        }, pdpZoom.zoom.config.animationDuration)
    },

    /**
     * Manual reset trigger
     */
    resetZoomView() {
        if (pdpZoom.zoom) {
            pdpZoom.zoom.reset();
        }
    }
}

export default pdpZoom;
